<div class="p-4">
  <app-user-profile-widget />
</div>
<div class="p-4">
  <p-panel header="User Account Information" iconPos="start">
    <ng-template #headericons let-collapsed>
      <i class="pi pi-chevron-right duration-150" [class]="{ 'rotate-90': !collapsed }"></i>
    </ng-template>
    <app-assign-usergroups [user]="userId" />
  </p-panel>
</div>
